import React from 'react';
import TopAndBottomBar from '../components/TopAndBottomBar';
import ContentWrapper from '../components/ContentWrapper';
import { useParams } from 'react-router-dom'
import Content from '../components/Content'
import CourseActionsBar from '../components/courseContent/CourseActionsBar';
import { useQuery } from '@apollo/react-hooks'
import { contentQueries } from '../graphql/queries';

const ContentRoute = props => {
  const { cursoId, forum, trails, open, progresso, ...rest } = props
  const { conteudoId } = useParams()
  const { loading, error, data } = useQuery(contentQueries.GET_CONTENT, {
    variables: { id: conteudoId }
  })

  const content = (data || {}).conteudo

  return (
    <>
      <ContentWrapper open={open}>
        <Content id={conteudoId} courseId={cursoId} content={content} loading={loading} error={error} trails={trails} {...rest} />
      </ContentWrapper>
      <TopAndBottomBar open={open} bottomBar>
        <CourseActionsBar conteudoId={conteudoId} cursoId={cursoId} forum={forum} content={content} loading={loading} trails={trails} progresso={progresso} error={error} {...rest} />
      </TopAndBottomBar>
    </>
  )
}
export default ContentRoute;